import React from 'react';
import ReportingMarketingSmsPage from '../components/ReportingMarketingSmsPage';

const ReportingMarketingSmsApp = (props) => (
  <ReportingMarketingSmsPage {...props} />
);

export default ReportingMarketingSmsApp;
